/* unplugin-vue-components disabled */import { render } from "./w-checkbox.vue?vue&type=template&id=6830e56f&scoped=true&ts=true"
import script from "./w-checkbox.vue?vue&type=script&lang=ts"
export * from "./w-checkbox.vue?vue&type=script&lang=ts"

import "./w-checkbox.vue?vue&type=style&index=0&id=6830e56f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6830e56f"]])

export default __exports__